<template>
  <div class="banner" :class="{ inside, hover, ready: essential }">
    <v-progress-circular v-if="loading" class="banner-loading" indeterminate color="primary" />
    <template v-else>
      <v-carousel class="banner-gallery elevation-0" :interval="interval" hide-controls hide-delimiters>
        <v-carousel-item v-for="item in value" :key="item.id">
          <div class="banner-gallery-item" :style="`background-image: url('${item.source}');`" />
        </v-carousel-item>
      </v-carousel>
      <div v-if="darken" class="banner-darken" />
    </template>
    <div class="banner-content"><slot /></div>
  </div>
</template>

<script>
export default {
  name: 'banner',
  props: {
    value: { type: Array, default: () => [] },
    interval: { type: Number, default: 10000 },
    darken: Boolean,
    inside: Boolean,
    hover: Boolean,
    loading: Boolean,
    essential: Boolean
  }
}
</script>

<style lang="scss">
@import '../styles/library';

.banner {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 0;
  min-height: 100vh;
  background-color: #000000;

  // vuetify bug fix
  .v-carousel, .v-carousel__item, .v-window, .v-window__container, .v-window-item { height: 100% !important; }

  .banner-gallery {
    position: absolute;
    @extend %full-container;
    transform: scale(1.01);
    transition: 5s ease;

    .banner-gallery-item {
      @extend %full-container;
      @extend %background-image;
    }
  }

  .banner-loading { @extend %align-center; }

  .banner-darken {
    position: absolute;
    @extend %full-container;
    background-color: rgba(0, 0, 0, .45);
    transition: background-color 5s ease;
  }

  .banner-content {
    position: absolute;
    width: 98%;
    max-width: 360px;
    @extend %align-center;
    text-align: center;
    color: #ffffff;
    opacity: 0;
    transition: opacity 1.5s ease;
  }

  &.inside {
    height: 100%;
    min-height: 0;
  }

  &.hover:hover {
    .banner-gallery { transform: scale(1.2); }
    .banner-darken { background-color: rgba(0, 0, 0, 0); }
    .banner-content { opacity: 0; }
  }

  &.ready {
    .banner-content { opacity: 1; }
  }
}
</style>
